const baseUrl = "https://server.escrowme.net";
//const baseUrl = "https://escraowme.cyclic.app"

export const api = `${baseUrl}/api/v2`;

export const generatePublicUrl = (fileName) => {
  return `${baseUrl}/${fileName}`;
};
